export default __webpack_public_path__ + "1faab64b7fb728bfd9069ad3574271ec.png";